<template>
  <div class="ChartsAlarmConfiger">
    <div class="is-show-right">
      <p>是否开启语音播报</p>
      <el-switch
        v-model="value.isOpenAlarmBroadcast"
        active-color="#1989fa"
        size="mini"
        inactive-color="#333"
        @change="changeSetting"
      >
      </el-switch>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChartsAlarmConfiger',
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      value: this.propertyData.alarmBroadcast.value,
    };
  },
  components: {},
  mounted() {},
  methods: {
    changeSetting() {
      console.log(this.value);
      /* 更新数据 */

      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: this.value,
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.is-show-right {
  box-sizing: border-box;
  padding: 0 15px;
  width: 100%;
  height: 43px;
  color: #a0a1b4;
  font-size: 14px;
  line-height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .el-select {
    width: 192px;

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);

      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
}
:deep().el-switch {
    margin: auto 0;
    .el-switch__core {
      background: #55597b;
      border: none;
      height: 10px;
      width: 30px !important;
      .el-switch__action {
        top: -2px;

        background: #c9cae5;

        width: 14px;
        height: 14px;
      }
    }
    &.is-checked {
      .el-switch__core {
        background: linear-gradient(143deg, #335ae9, #6f6ff5);
        .el-switch__action {
          left: 100%;
          background: #ffffff;
          margin-left: -14px;
        }
      }
    }
  }
</style>